import React from "react";
import { makeStyles } from "@mui/styles";
import classNames from "classnames";
import { DrawerLabel } from "componentLibrary";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    container: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%"
    }
  };
});
var DrawerFormElement = function DrawerFormElement(_ref) {
  var title = _ref.title,
    children = _ref.children,
    appendIcon = _ref.appendIcon;
  var classes = useStyles();
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(classes.container),
    children: [/*#__PURE__*/_jsx(DrawerLabel, {
      appendIcon: appendIcon,
      children: title || " "
    }), children]
  });
};
export default DrawerFormElement;